import React, { FC, SVGAttributes } from "react"
import SVG from "../svg"

const Electric: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <SVG
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M152.56.584a.44.44 0 01.416-.584h179.829a.44.44 0 01.421.31l82.598 266.861a.44.44 0 01-.421.57H295.684a.22.22 0 00-.211.28l68.662 241.705c.134.469-.481.775-.774.385L96.529 155.267a.44.44 0 01.352-.704h108.655a.22.22 0 00.207-.292L152.56.584z"
                clipRule="evenodd"
            ></path>
        </SVG>
    )
}

export default Electric
